<template>
  <div class="space-y-4">
    <h2>{{ t('debitBookingCategories') }}</h2>
    <MultipleValuesListField
      name="debitBookingCategories"
      :button-text="t('addEntry')"
      :field-settings="fieldSettings"
      show-delete-alert
    />
  </div>
</template>

<script lang="ts" setup>
import MultipleValuesListField, {
  type FieldSettings,
} from '@/components/MultipleValuesListField.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { VehicleCategory } from '@/entities/vehicle-category.enum';

const { t } = useI18n();

const fieldSettings = computed<FieldSettings[]>(() => [
  {
    name: 'categories',
    label: t('categories'),
    type: 'multiselect',
    options: Object.values(VehicleCategory).map((value) => ({
      label: t(`categories.${value}`),
      value,
    })),
  },
  {
    name: 'netPurchasePriceLt',
    label: t('maxNetPurchasePrice'),
    type: 'number',
    adornment: '€',
  },
]);
</script>

<i18n lang="json">
{
  "en": {
    "debitBookingCategories": "Debit Booking Categories",
    "addEntry": "+ Add debit booking category",
    "categories": "Categories",
    "maxNetPurchasePrice": "Max. Net Purchase Price"
  },
  "de": {
    "debitBookingCategories": "EC-Karten-Buchungskategorien",
    "addEntry": "+ EC-Karten-Buchungskategorie hinzufügen",
    "categories": "Kategorien",
    "maxNetPurchasePrice": "Max. Nettokaufpreis"
  },
  "es": {
    "debitBookingCategories": "Categorías de cargo en tarjeta",
    "addEntry": "+ Añadir categoría de cargo",
    "categories": "Categorías",
    "maxNetPurchasePrice": "Precio neto de compra máx."
  }
}
</i18n>
